import { __makeTemplateObject } from 'tslib';
import styled from 'styled-components';
import { space, layout, borders, positioning } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var Image = /*#__PURE__*/styled("img").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Image",
  componentId: "sc-vwhz1a-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n  height: auto;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  max-width: 100%;\n  height: auto;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), flexboxes, space, layout, borders, positioning);
var templateObject_1;

export { Image };
//# sourceMappingURL=Image.js.map
